import React from 'react';
import { RefreshCw, X } from 'lucide-react';

/**
 * Toast notification shown when a new version of the app is available
 */
function UpdateToast({ onUpdate, onDismiss }) {
  return (
    <div className="fixed bottom-above-nav left-4 right-4 md:bottom-20 md:left-auto md:right-4 md:w-96 z-50 animate-slide-up">
      <div className="bg-blue-600 text-white rounded-lg shadow-lg p-4 flex items-center gap-3">
        <RefreshCw className="w-5 h-5 flex-shrink-0" />
        <div className="flex-1 min-w-0">
          <p className="font-medium text-sm">Update available</p>
          <p className="text-xs text-blue-100">A new version is ready to install</p>
        </div>
        <div className="flex gap-2">
          <button
            onClick={onUpdate}
            className="px-3 py-1.5 bg-white text-blue-600 text-sm font-medium rounded hover:bg-blue-50 transition-colors"
          >
            Update
          </button>
          <button
            onClick={onDismiss}
            className="p-1.5 hover:bg-blue-500 rounded transition-colors"
            aria-label="Dismiss"
          >
            <X className="w-4 h-4" />
          </button>
        </div>
      </div>
    </div>
  );
}

export default UpdateToast;
